export enum MeetingFormatEnum {
  WEBINAR = 'webinar',
  LIVESTREAM = 'livestream',
}

export const MEETING_FORMAT_VALUES = Object.values(MeetingFormatEnum) as string[];

export function resolveMeetingFormat(
  value: string | undefined | null,
): MeetingFormatEnum {
  if (value === MeetingFormatEnum.LIVESTREAM) {
    return MeetingFormatEnum.LIVESTREAM;
  }
  return MeetingFormatEnum.WEBINAR;
}
